import styled, { css } from 'styled-components';

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.button<{ $isHidden: boolean }>(
  ({ theme: { palette }, $isHidden }) => css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 0;
    background: transparent;
    padding: 2px 0;
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    color: ${$isHidden ? palette.grey[500] : palette.grey[700]};
    text-decoration: ${$isHidden ? 'line-through' : 'none'};
  `,
);

export const LegendSwatch = styled.span<{ $color: string }>(
  ({ $color }) => css`
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background-color: ${$color};
  `,
);

export const GrafanaLink = styled.a(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    font-weight: 600;
    color: ${palette.primary.main};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `,
);

export const FullscreenBody = styled.div`
  width: 100%;
  min-width: 0;
`;
